const format = (k, v) => (v !== null && typeof v !== 'undefined' ? `${k}=${encodeURIComponent(v)}` : '');

export const querystring = (obj) => [].concat(...Object.entries(obj)
  .map(([k, v]) => (Array.isArray(v)
    ? v.map((arr) => querystring({ [k]: arr }))
    : format(k, v))))
  .filter((x) => x)
  .join('&');
